import React from 'react'
import { Table } from 'semantic-ui-react'
import { useFormContext, useWatch } from 'react-hook-form'
import { HeaderColumnTitle } from './style'
import { formatNumber } from '~/utils/helpers'

const HeiferPhasesTable:React.FC = () => {
  const { control } = useFormContext()

  const heiferPhases = useWatch({ control, name: 'rearingPhases' })

  function renderHeaders() {
    return heiferPhases.map(heiferPhase => {
      return <Table.HeaderCell key={heiferPhase.name}>
        {`${heiferPhase.name} (${heiferPhase.period})`}
      </Table.HeaderCell>
    })
  }

  function renderTableBody() {
    return <Table.Row>
      <HeaderColumnTitle>{'Anzahl Tage:'}</HeaderColumnTitle>
      {heiferPhases.map(heiferPhase => {
        return <Table.Cell key={`${heiferPhase.name}-body-table-cell`}>
          {`${formatNumber(heiferPhase.days, 2)} Tage`}
        </Table.Cell>
      })}
    </Table.Row>
  }

  return <>
    <Table
      celled
      striped
      style={{ margin: '2em 0em' }}
    >
      <Table.Header>
        <Table.Row>
          <HeaderColumnTitle>{'Aufzuchtphase:'}</HeaderColumnTitle>
          {renderHeaders()}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {renderTableBody()}
      </Table.Body>
    </Table>
  </>
  
}
export default HeiferPhasesTable